import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { business } from "@/data/siteConfig";

const fieldClass =
  "mt-2 border-white/10 bg-ink text-white placeholder:text-steel/50 focus-visible:ring-gold focus-visible:ring-1";

const Field = ({ label, name, type = "text", testid, placeholder }) => (
  <div>
    <Label htmlFor={name} className="text-xs font-bold uppercase tracking-wide text-steel-light">
      {label}
    </Label>
    <Input
      id={name}
      name={name}
      type={type}
      placeholder={placeholder}
      data-testid={testid}
      className={fieldClass}
    />
  </div>
);

export const ContactForm = () => {
  const onSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    toast.success("Thanks for reaching out", {
      description: `This form isn't connected yet — for the fastest response, please call ${business.phone}.`,
    });
    form.reset();
  };

  return (
    <form
      onSubmit={onSubmit}
      data-testid="contact-form"
      className="border border-white/10 bg-ink-surface p-6 md:p-8"
    >
      <h3 className="font-heading text-xl font-bold text-white">Send project details</h3>
      <p className="mt-2 text-sm text-steel">
        Prefer to write first? Share your job details below. Calling is still the fastest way to reach us.
      </p>

      <div className="mt-6 grid gap-5 sm:grid-cols-2">
        <Field label="Name" name="name" testid="cf-name" placeholder="Your name" />
        <Field label="Phone" name="phone" type="tel" testid="cf-phone" placeholder={business.phone} />
      </div>
      <div className="mt-5">
        <Field label="Email" name="email" type="email" testid="cf-email" placeholder="you@email.com" />
      </div>
      <div className="mt-5">
        <Label
          htmlFor="message"
          className="text-xs font-bold uppercase tracking-wide text-steel-light"
        >
          Tell us about your job
        </Label>
        <Textarea
          id="message"
          name="message"
          rows={5}
          data-testid="cf-message"
          placeholder="Safe brand & model, approximate size and weight, your location, and what's happening. Photos are welcome!"
          className={fieldClass}
        />
      </div>

      <button
        type="submit"
        data-testid="cf-submit"
        className="mt-6 inline-flex h-12 w-full items-center justify-center rounded-sm bg-gold font-heading text-sm font-bold uppercase tracking-[0.08em] text-ink transition-[transform,background-color] duration-300 hover:scale-[1.01] hover:bg-gold-dark active:scale-95"
      >
        Send Message
      </button>
      <p className="mt-4 text-xs leading-relaxed text-steel/70">
        This form sends us a message — it does not book an appointment. Every job is
        evaluated individually, so we'll follow up to discuss the details.
      </p>
    </form>
  );
};
